import * as Yup from 'yup';

// Validação para informações básicas
export const userValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Nome é obrigatório')
    .min(3, 'Nome deve ter no mínimo 3 caracteres')
    .max(255, 'Nome deve ter no máximo 255 caracteres'),

  email: Yup.string()
    .email('E-mail inválido')
    .required('E-mail é obrigatório')
    .max(255, 'E-mail deve ter no máximo 255 caracteres'),

  cpf_or_rg: Yup.string()
    .required('CPF/RG é obrigatório')
    .max(20, 'CPF/RG deve ter no máximo 20 caracteres'),

  phone: Yup.string()
    .required('Telefone é obrigatório')
    .max(20, 'Telefone deve ter no máximo 20 caracteres'),

birth_date: Yup.date()
  .max(new Date(), 'Data de nascimento não pode ser no futuro')
  .min(new Date('1900-01-01'), 'Data de nascimento inválida'),


  role: Yup.string()
    .required('Tipo de usuário é obrigatório'),
});

// Schema para criação (senha obrigatória)
export const createUserValidationSchema = userValidationSchema.shape({
  password: Yup.string()
    .min(6, 'Senha deve ter no mínimo 6 caracteres')
    .required('Senha é obrigatória'),
});

// Schema para edição (senha opcional)
